import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Document, File, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  file: File;
  downloadDocumentContent(
    request: Boundaries["downloadDocumentContent"]["request"],
  ): void;
}

function useDownloadDocumentContent(
  document: Identifiable<Document>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isDownloadDocumentContentRequestPending(document),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isDownloadDocumentContentRequestSuccess(document),
    ),
    isRequestFailure: useSelector(() =>
      selector.isDownloadDocumentContentRequestFailure(document),
    ),
    file: useSelector(() => selector.getDownloadedDocumentContent(document)),
    downloadDocumentContent: core.downloadDocumentContent,
  };
}

export { useDownloadDocumentContent };
